import React from 'react';
import { IDirectoryEntry } from 'services/CrmApi/types/DirectoryEntry';
import { UserDate } from '../UserDate/UserDate';
import { isContactProfile } from 'containers/CRM/helpers';

export interface IContactPageTitleRightPartProps {
  directoryEntry?: IDirectoryEntry;
}

export const ContactPageTitleRightPart: React.FC<IContactPageTitleRightPartProps> = ({ 
  directoryEntry
}) => {
  if (!directoryEntry?.profile || !isContactProfile(directoryEntry?.profile)) {
    return null;
  }

  return (
    <div className="flex flex-col gap-[5px]">
      <UserDate text="Created by:" date={directoryEntry?.createdDate} user={directoryEntry?.createdBy} />
      <UserDate text="Modified by:" date={directoryEntry?.updatedDate} user={directoryEntry?.updatedBy} />
    </div>
  );
}
